import React, { useState } from 'react';
import { Table, Button } from 'reactstrap';
import * as Icon from 'react-feather';
import PropTypes from 'prop-types';
import ModalConfirmarBorrar from '../modals/ModalConfirmarBorrar';

const DynamicTable = ({ headers, rows, onEdit, update, setUpdate, endpoint }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFactura, setSelectedFactura] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const handleDeleteClick = (numFactura) => {
    if (numFactura) {
      setSelectedFactura(numFactura);
      toggleModal();
    }
  };

  const handleDeleteConfirm = () => {
    toggleModal();
  };

  const filteredRows = rows.filter((row) => (endpoint === 1 ? row.numrecibo : row.num));

  const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

  const changePage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <>
      {isModalOpen && (
        <ModalConfirmarBorrar
          isOpen={isModalOpen}
          toggle={toggleModal}
          numFactura={selectedFactura}
          onDeleteConfirm={handleDeleteConfirm}
          update={update}
          setUpdate={setUpdate}
          endpoint={endpoint}
        />
      )}

      <Table striped>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              {headers.map((header, headerIndex) => (
                <td key={headerIndex}>{row[header.toLowerCase()]}</td>
              ))}
              <td>
                {endpoint !== 1 && (
                  <Button onClick={() => onEdit(row)}>
                    <Icon.Edit />
                  </Button>
                )}
                <Button
                  color="danger"
                  onClick={() => handleDeleteClick(endpoint === 1 ? row.numrecibo : row.num)}
                >
                  <Icon.Trash />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {totalPages > 1 && (
        <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
          <Button
            size="sm"
            color="light"
            onClick={() => changePage(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <Icon.ChevronLeft size={18} />
          </Button>
          <span className="mx-2">
            Página {currentPage} de {totalPages}
          </span>
          <Button
            size="sm"
            color="light"
            onClick={() => changePage(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <Icon.ChevronRight size={18} />
          </Button>
        </div>
      )}
    </>
  );
};

DynamicTable.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      descripcion: PropTypes.string,
      precio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      unidades: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      importe: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      impuesto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      num: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      numrecibo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  onEdit: PropTypes.func.isRequired,
  update: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  setUpdate: PropTypes.func,
  endpoint: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default DynamicTable;
